import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { X, ImageOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ImagePreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  stageName: string;
}

const ImagePreviewDialog: React.FC<ImagePreviewDialogProps> = ({
  isOpen,
  onClose,
  imageUrl,
  stageName,
}) => {
  const [hasError, setHasError] = useState(false);

  const handleImageError = () => {
    if (!hasError) {
      
      setHasError(true);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 overflow-hidden">
        <div className="relative">
          {hasError ? (
            <div className="flex flex-col items-center justify-center p-10 bg-gray-100 min-h-[300px]">
              <ImageOff className="h-12 w-12 mb-4 text-muted-foreground" />
              <p className="text-lg font-medium text-center">Fotoğraf yüklenemedi</p>
              <p className="text-sm text-muted-foreground mt-2 text-center">
                {imageUrl.length > 50 ? `${imageUrl.substring(0, 50)}...` : imageUrl}
              </p>
            </div>
          ) : (
            <img
              src={imageUrl}
              alt={`${stageName} fotoğrafı`}
              className="w-full h-auto object-contain"
              onError={handleImageError}
            />
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="absolute top-2 right-2 bg-black/20 hover:bg-black/40 text-white rounded-full"
          >
            <X className="h-5 w-5" />
          </Button>
        </div>
        <div className="p-4 bg-background">
          <h3 className="text-lg font-medium">{stageName}</h3>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog; 